// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"nameCell__7L2Wq","logo":"logo__HVW3A","content":"content__3C0vr","name":"name__l7mkQ"};